<template>
  <v-container fluid>
    <v-card>
      <v-card-title v-if="!showMessage">
        <v-btn
          color="warning"
          class="mr-4"
          dark
          @click="$htmlToPaper('genericReport')"
        >
          IMPRIMIR
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="loader">CARREGANDO...</div>
        <div v-if="showMessage">{{ message }}</div>
        <GenericReport
          v-else
          :data="dataReport"
          :filter="filter"
          :prefecture="prefecture"
          ref="allComponent"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import GenericReport from "./reportModel";
export default {
  components: { GenericReport },
  mixins: [Helpers],
  props: {
    prefecture_id: null,
    startDate: null,
    endDate: null,
  },
  data: () => ({
    dataReport: [],
    filter: {},
    prefecture: [],
    showMessage: false,
    loader: false,
    message: "",
  }),
  created() {
    this.loadTceReport();
    this.Helpers;
  },
  methods: {
    loadTceReport() {
      this.message = "";
      this.showMessage = false;
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);

      this.filter = {
        prefecture_id: this.prefecture_id,
        startDate: this.startDate,
        endDate: this.endDate,
      };

      this.$http.post(`/parts-and-services/report`, this.filter).then((r) => {
        if (r.data.error) {
          this.message = r.data.error;
          this.showMessage = true;
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        } else {
          this.dataReport = r.data;
          this.$http
            .get(`/prefectures/${this.filter.prefecture_id}`)
            .then((p) => {
              this.prefecture = p.data[0];
              this.loader = false;
              this.$store.dispatch("setLoader", this.loader);
            });
        }
      });
    },
  },
};
</script>

<style>
</style>